import ExportCSV from '@/components/common/ExportCSV';
import ClosePositionModal from '@/components/modal/ClosePositionModal';
import HistoricSearchModal from '@/components/modal/HistoricSearchModal';
import { HistoricSearch } from '@/components/modules/Blotters';
import ModuleWindow, { moduleHeaderClassName } from '@/components/mosaic/ModuleWindow';
import ModuleWindowControls from '@/components/mosaic/ModuleWindowControl';
import { useAppDispatch } from '@/state/hooks';
import { setActiveTicker } from '@/state/reducers/tickerSlice';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useLanguage from '@/utils/hooks/useLanguage';
import { UseScreenSizesReturn } from '@/utils/hooks/useScreenSizes';
import { tabIcon } from '@/utils/hooks/useXplorSpotLayout';
import { useCallback, useState } from 'react';
import Blotters from '.';
import { OpenPositionRow } from './OpenPositionTable';

interface BlottersModuleProps {
    screen: UseScreenSizesReturn;
    tradingModule: {
        title: string;
        component?: JSX.Element | undefined;
    };
}

const BlottersModule = (props: BlottersModuleProps) => {
    const { screen, tradingModule } = props;
    const dispatch = useAppDispatch();
    const lang = useLanguage();

    const [CSVData, setCSVData] = useState<any[]>([]);
    const [prefillValues, setPrefillValues] = useState<OpenPositionRow>();

    const orderDisclosure = useDisclosure(false);
    const historicSearchDisclosure = useDisclosure(false);

    const onOrderModal = useCallback(
        (row: OpenPositionRow) => {
            orderDisclosure[1].open();
            dispatch(setActiveTicker(row.market));
            setPrefillValues(row);
        },
        [orderDisclosure]
    );

    return (
        <ModuleWindow
            {...props}
            renderToolbar={() => (
                <div className={moduleHeaderClassName} dir={lang.dir}>
                    <div className="h-full flex items-center p-2 gap-2">
                        {tabIcon[tradingModule?.title || ''] && (
                            <div className="flex items-center justify-center bg-brand-neutral-700 rounded-full p-1">
                                {tabIcon[tradingModule?.title || '']({
                                    className: 'w-4 h-4',
                                    'aria-hidden': true
                                })}
                            </div>
                        )}
                        <span className="font-semibold">{tradingModule?.title}</span>

                        <div className="flex items-center h-full">
                            {(screen.laptop || screen.desktop) && (
                                <div
                                    title="Download to CSV"
                                    className="cursor-pointer hover:bg-brand-primary p-2 rounded-sm flex items-center">
                                    <ExportCSV csvData={CSVData} />
                                </div>
                            )}
                            <HistoricSearch handlers={historicSearchDisclosure[1]} />
                        </div>
                    </div>
                    <ModuleWindowControls screen={screen} />
                </div>
            )}>
            <div id="orders" className="h-full bg-brand-background">
                <Blotters setCSVData={setCSVData} onOrderModal={onOrderModal} />
            </div>
            <ClosePositionModal
                prefillValues={prefillValues}
                opened={orderDisclosure[0]}
                handlers={orderDisclosure[1]}
            />
            <HistoricSearchModal opened={historicSearchDisclosure[0]} handlers={historicSearchDisclosure[1]} />
        </ModuleWindow>
    );
};

export default BlottersModule;
